export const scrollElementIntoView = (element?: Element | null, block: ScrollLogicalPosition = "nearest"): boolean => {
  if (!element || typeof element.scrollIntoView !== "function") {
    return false
  }

  element.scrollIntoView({ behavior: "smooth", block, inline: "nearest" })
  return true
}

export const scrollElementToTop = (element?: HTMLElement | null): boolean => {
  if (!element) {
    return false
  }

  if (typeof element.scrollTo === "function") {
    element.scrollTo({ behavior: "smooth", top: 0 })
  } else {
    element.scrollTop = 0
  }
  return true
}
